import Header from "./header";
import Sidebar from "./sidebar";
import { Outlet } from "react-router-dom";
export default function HydrogenLayout() {
  return (
    <main className="flex min-h-screen flex-grow max-w-[1800px] mx-auto">
      {/* ① Sidebar */}
      <Sidebar className="fixed hidden xl:block dark:bg-gray-50" />

      {/* ② Content wrapper */}
      <div className="flex w-full flex-col xl:ms-[270px] xl:w-[calc(100%-270px)] 2xl:ms-72 2xl:w-[calc(100%-288px)]">
        <Header />

        {/* ③ Page‑level content goes here */}
        <div className="flex flex-grow flex-col px-4 pb-6 pt-2 md:px-5 lg:px-6 lg:pb-8 3xl:px-8 3xl:pt-4 4xl:px-10 4xl:pb-9">
          <Outlet />
        </div>
      </div>
    </main>
  );
}
